import getCookie from "../util/cookieCheck.js";

const userId = getCookie('CommerceCustomerId');
if (window.hj !== undefined && userId) {
    window.hj('identify', userId, { sitecoreUserId: userId });
}